import './instagram_message.js.coffee'
Namespace 'Models'

class Models.InstagramMessageStoryMention extends Models.InstagramMessage
  constructor: (builder) ->
    super(builder)
    @attachments = builder.attachments

  accepts: (visitor) ->
    visitor.visit_instagram_message_story_mention(@)

  getType: ->
    'story_mention'

  storiesAreExpired: ->
    millisecondsInAnHour = 3600000
    (new Date().valueOf() - @timestamp) / millisecondsInAnHour >= 24
